import { createRouter, createWebHistory } from "vue-router";
import Cookies from "js-cookie";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "login",
      component: () => import("@/login/login.vue"),
    },
    {
      //主界面
      path: "/index",
      name: "index",
      component: () => import("@/views/home/index.vue"),
      redirect: "/accountInfoManagement",
      children: [
        {
          path: "/accountInfoManagement",
          name: "accountInfoManagement",
          component: () => import("@/views/accountInfoManagement/index.vue"),
          meta: { requiresUser: true },
        },
        {
          path: "accountInfoManagement/:id", // 项目详情路由
          name: "testInfoDetail",
          component: () =>
            import("@/views/accountInfoManagement/components/detail.vue"),
          meta: { title: "检测详情" },
        },
        {
          path: "/testManagement",
          name: "testManagement",
          component: () => import("@/views/testManagement/index.vue"),
          meta: { requiresUser: true },
        },
        {
          path: "/samplingTubeCodeManagement",
          name: "samplingTubeCodeManagement",
          component: () =>
            import("@/views/samplingTubeCodeManagement/index.vue"),
          meta: { requiresUser: true },
        },
        {
          path: "samplingTubeCodeManagement/:id", // 项目详情路由
          name: "samplingTubeCodeDetail",
          component: () =>
            import("@/views/samplingTubeCodeManagement/components/detail.vue"),
          meta: { title: "样管详情" },
        },
        //代理商
        {
          path: "/agentManagement",
          name: "agentManagement",
          component: () => import("@/views/agentManagement/index.vue"),
          meta: { requiresUser: true },
        },
        {
          path: "/nurseOrderManagement",
          name: "nurseOrderManagement",
          component: () => import("@/views/nurseOrderManagement/index.vue"),
          meta: { requiresUser: true },
        },
        {
          path: "/suctomerService",
          name: "suctomerService",
          component: () => import("@/views/customerService/index.vue"),
          meta: { requiresUser: true },
        },
        {
          path: "/shippingApplicationManagement",
          name: "shippingApplicationManagement",
          component: () => import("@/views/shippingApplicationManagement/index.vue"),
          meta: { requiresUser: true },
        },
        {
          path: "/samplingLocationManagement",
          name: "samplingLocationManagement",
          component: () => import("@/views/samplingLocationManagement/index.vue"),
          meta: { requiresUser: true },
        },
        {
          path: "/testProductInfoManagement",
          name: "testProductInfoManagement",
          component: () => import("@/views/testProductInfoManagement/index.vue"),
          meta: { requiresUser: true },
        },
        {
          path: "/eSignatureManagement",
          name: "eSignatureManagement",
          component: () => import("@/views/eSignatureManagement/index.vue"),
          meta: { requiresUser: true },
        },
        {
          path: "/reportManagement",
          name: "reportManagement",
          component: () => import("@/views/reportManagement/index.vue"),
          meta: { requiresUser: true },
        },
        {
          path: "/nurseManagement",
          name: "nurseManagement",
          component: () => import("@/views/nurseManagement/index.vue"),
          meta: { requiresUser: true },
        },
         {
          path: "/customerManagement",
          name: "customerManagement",
          component: () => import("@/views/customerManagement/index.vue"),
          meta: { requiresUser: true },
        },
        {
          path: "/reportConfig",
          name: "reportConfig",
          component: () => import("@/views/reportConfig/index.vue"),
          meta: { requiresUser: true },
        },
        {
          path: "/mallConfig",
          name: "mallConfig",
          component: () => import("@/views/mallConfig/index.vue"),
          meta: { requiresUser: true },
        },
        // 修改promotionCenter路由，添加children
        {
          path: "/promotionCenter",
          name: "promotionCenter",
          component: () => import("@/views/promotionCenter/index.vue"),
          meta: { requiresUser: true },
          redirect: "/promotionCenter/promotionPerMan", // 添加重定向
          children: [
            {
              path: "promotionPerMan",
              name: "promotionPerMan",
              component: () =>
                import("@/views/promotionCenter/views/promotionPerMan.vue"),
              meta: { title: "推广人管理" },
            },
            {
              path: "promotionPerBoard",
              name: "promotionPerBoard",
              component: () =>
                import("@/views/promotionCenter/views/promotionPerBoard.vue"),
              meta: { title: "推广人员看板" },
            },
            {
              path: "promotionBindTube",
              name: "promotionBindTube",
              component: () =>
                import("@/views/promotionCenter/views/promotionBindTube.vue"),
              meta: { title: "订单号绑定采样管码" },
            },
            {
              path: "promotionClaimRecord",
              name: "promotionClaimRecord",
              component: () =>
                import("@/views/promotionCenter/views/promotionClaimRecord.vue"),
              meta: { title: "用户领取记录" },
            },
          ],
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  NProgress.start();
  const tokenkey = Cookies.get("token");
  if (tokenkey) {
    next();
  } else {
    if (to.path == "/") {
      //判断是否已经进入登录页面path  防止死循环
      next();
    } else {
      next("/");
    }
  }
});

router.afterEach((to, from, next) => {
  NProgress.done(); //进度条结束
});

export default router;
